// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { captureRecoveryCallback } from '@/lib/recoveryLock';

const SUPABASE_URL = "https://ebhjbrnlrshsjrctwejs.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImViaGpicm5scnNoc2pyY3R3ZWpzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc3Nzc4NjksImV4cCI6MjA3MzM1Mzg2OX0.NmTKfE8xaVqSlhMAJaXbcwTfFcnHeKSECo8NK4ZAyU4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// AUTH-CADASTRO Ato 1: ler a marca de recuperação antes de o cliente trocar o código (e apagar o verificador)
captureRecoveryCallback();

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // AUTH-CADASTRO Ato 1: link por e-mail só abre sessão no navegador que pediu
    flowType: 'pkce',
  },
  global: {
    headers: {
      'X-Client-Info': 'supabase-js-web',
    },
  },
  db: {
    schema: 'public',
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});